import { isAiWritingAssistantEnabled } from 'bundles/authoring/featureFlags';
import { useTeachContext } from 'bundles/teach-course/contexts/useTeachContext';

export const useAiWritingAssistantSupported = () => {
  const context = useTeachContext();
  return !!context.course && isAiWritingAssistantEnabled();
};
